exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.arrbox[data-v-c71ff98a] {\r\n  background-color: white;\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n  margin-bottom: 0px;\r\n  padding: 0 5px;\r\n  text-align: left;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  width: 90%;\n}\r\n", ""]);

// exports
